import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl" style={{ color: 'oklch(0.56 0.170 15)' }}></i>
            </div>
            <span className="text-xl font-bold font-heading text-foreground-950">玫瑰视频</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 7).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/70'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影片..."
                className="w-48 px-4 py-1.5 text-sm rounded-full bg-background-100 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
              />
              <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
              </div>
            </div>
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3">
            <div className="relative mb-3">
              <input
                type="text"
                placeholder="搜索影片..."
                className="w-full px-4 py-2 text-sm rounded-full bg-background-100 border border-background-300/60 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-foreground-400 text-sm"></i>
              </div>
            </div>
            <div className="grid grid-cols-4 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-1 px-2 py-2 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
                >
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${cat.icon} text-foreground-700 text-base`}></i>
                  </div>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
            <Link
              to="/about"
              className="block text-center mt-3 py-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}